import React from 'react'

function AccountReport() {
  return (
    <div>AccountReport</div>
  )
}

export default AccountReport